// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2x-sW","buttons":"SendReceipts_buttons__rP2LT","email":"SendReceipts_email__3Q5_l","bookApptTitle":"SendReceipts_bookApptTitle__30nYL"};